// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1lFxm","tab":"ProcedureTabs_tab__e6XIP"};